import { render, staticRenderFns } from "./PipeTemperatureRadio.vue?vue&type=template&id=0fad97de&scoped=true&"
import script from "./PipeTemperatureRadio.vue?vue&type=script&lang=js&"
export * from "./PipeTemperatureRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad97de",
  null
  
)

export default component.exports